/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Eigentuemer } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * EigentuemerService - axios parameter creator
 * @export
 */
export const EigentuemerServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Eigentuemer
         * @summary Eigentuemer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEigentuemer: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/eigentuemer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EigentuemerService - functional programming interface
 * @export
 */
export const EigentuemerServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EigentuemerServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Eigentuemer
         * @summary Eigentuemer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEigentuemer(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Eigentuemer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEigentuemer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EigentuemerService - factory interface
 * @export
 */
export const EigentuemerServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EigentuemerServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Eigentuemer
         * @summary Eigentuemer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEigentuemer(options?: any): AxiosPromise<Array<Eigentuemer>> {
            return localVarFp.getEigentuemer(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EigentuemerService - interface
 * @export
 * @interface EigentuemerService
 */
export interface EigentuemerServiceInterface {
    /**
     * Liefert eine Liste von Eigentuemer
     * @summary Eigentuemer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EigentuemerServiceInterface
     */
    getEigentuemer(options?: any): AxiosPromise<Array<Eigentuemer>>;

}

/**
 * EigentuemerService - object-oriented interface
 * @export
 * @class EigentuemerService
 * @extends {BaseAPI}
 */
export class EigentuemerService extends BaseAPI implements EigentuemerServiceInterface {
    /**
     * Liefert eine Liste von Eigentuemer
     * @summary Eigentuemer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EigentuemerService
     */
    public getEigentuemer(options?: any) {
        return EigentuemerServiceFp(this.configuration).getEigentuemer(options).then((request) => request(this.axios, this.basePath));
    }
}
